import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    animatedDot: ({ size }) => ({
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        margin: theme.spacing(0, 0.04 * size),
    }),
}));
